// Angular
import { Component, OnInit } from '@angular/core';
// Services
// External
import { ApiService } from '../../services/api';

import * as lodash from 'lodash';
import { OAuthService } from '../../services/o-auth';

@Component({
  templateUrl: './follower-request.component.html'
})
export class FollowerRequestComponent implements OnInit {
  public query: string;
  public filterArg: any;
  public club: any;
  public users: Array<any>;

  public pageSize: number;
  public imageLoader: boolean = true;

  constructor(private apiService: ApiService, private oAuthService: OAuthService) {
    this.pageSize = 30;
    this.query = '';
    this.filterArg = {
      fullName: ""
    }
    this.club = this.oAuthService.getClub();

  }

  ngOnInit() {
    this.apiService.object(`/user-follow-request/${this.club.cid}`)
      .then(result => {

        if (result) {
          this.users = [];
          lodash.forEach(result, (item, key) => {

            if (key) {
              this.apiService.object(`/users/${key}`)
                .then((result1) => {
                  result1.key = key
                  result1.follow_status = item
                  this.users.push(result1);
                  // console.log(result);
                }, error => {
                  console.error(error);
                });

            }



          });

        }
        this.imageLoader = false;
      })
  }
  public activate(item) {
    if (confirm('Are you sure,you want to accept this request?')) {

      let update = {}
      update["user-followers/" + this.club.cid + "/followers/" + item.key] = true
      update["user-followings/" + item.key + "/followings/" + this.club.cid] = true
      update["user-follow-request/" + this.club.cid + "/" + item.key] = 2

      this.apiService.bulkUpdate(update)
        .then(() => {
          // this.goToPage(this.currentPage);
          item.follow_status = 2
        })
        .catch(error => {
          console.error(error);
        });





    }
  }

  public deactivate(item) {
    if (confirm('Are you sure,you want to reject the request?')) {


      let update = {}

      update["user-follow-request/" + this.club.cid + "/" + item.key] = 3

      this.apiService.bulkUpdate(update).then(() => {
        // this.goToPage(this.currentPage);
        item.follow_status = 3

      })
        .catch(error => {
          console.error(error);
        });





    }
  }
}
